module.exports = __webpack_public_path__ + "img/Cloud_Icon.f281e64d.png";